export default __webpack_public_path__ + "static/media/chart.33444b90.svg";